import { ContactFaq, InfoSection, LinkCardsSection, SocialLinksSection } from './components';
import { ContactFaqProps } from './interface-contact';

export const ViewContact = ({ faqQuestions }: ContactFaqProps) => {
  return (
    <>
      <InfoSection />
      <LinkCardsSection />
      <ContactFaq faqQuestions={faqQuestions} />
      <SocialLinksSection />
    </>
  );
};
